require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./benton-county-transition-program.json") })
        }
      }, "path---benton-county-transition-program");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---benton-county-transition-program!./.cache/json/benton-county-transition-program.json
// module id = 845
// module chunks = 231608221292675